// Flow types automatically removed

import classNames from 'classnames';
import styles from './styles/VimeoPlayer.scss';

//example url: `https://player.vimeo.com/video/${videoId}?title=0&byline=0`
const VimeoPlayer = props => {
    const { url, className } = props;
    const wrapperClass = classNames(styles.wrapper, className);
    return (
        <div className={wrapperClass}>
            {url ? (
                <iframe src={url} frameBorder="0" allowFullScreen className={styles.iframe} />
            ) : (
                <span>No video url</span>
            )}
        </div>
    );
};

export { VimeoPlayer };
